module.exports = __webpack_public_path__ + "img/彭祥俊.634705b8.jpg";